import {
  isTypeHeaderLinkGroup,
  TypeComponentCtaLink,
  TypeHeader,
  TypeHeaderDropdownMenu,
  TypeHeaderRichMenu,
} from '@/types/ctf'

export type AnyLinkType =
  | TypeComponentCtaLink<'WITHOUT_UNRESOLVABLE_LINKS'>
  | TypeHeaderDropdownMenu<'WITHOUT_UNRESOLVABLE_LINKS'>
  | TypeHeaderRichMenu<'WITHOUT_UNRESOLVABLE_LINKS'>

export const flattenLinkGroups = (links: TypeHeader<'WITHOUT_UNRESOLVABLE_LINKS'>['fields']['mainNavItems']) =>
  links?.reduce((acc, link) => {
    if (!link) return acc
    if (isTypeHeaderLinkGroup(link)) {
      return [...acc, ...((link.fields.links || []) as AnyLinkType[])]
    }
    return [...acc, link] as AnyLinkType[]
  }, [] as AnyLinkType[]) || []
